<template>
  <div>
  <div v-if="items.length < 1">
    {{$t('views.exsborder.list.noOrders')}}
  </div>
  <table v-else class="table table-sm table-striped table-hover">
    <thead>
    <tr>
      <th>{{$t('views.exsborder.list.idCase')}}</th>
      <th>{{$t('views.exsborder.list.orderStatus')}}</th>
      <th>{{$t('views.exsborder.list.valueNetto')}}</th>
      <th>{{$t('views.exsborder.list.valueBrutto')}}</th>
      <th>{{$t('views.exsborder.list.firm')}}</th>
      <th>{{$t('views.exsborder.list.tags')}}</th>
      <th colspan="2" />
    </tr>
    </thead>
    <tbody>
    <tr v-for="item in items" :key="item['@id']" v-bind:class="{'table-success': item.completed, 'table-warning': item.priced}">
      <td>
        <router-link v-if="item.idCase"
          :to="{name: 'EXCMCaseShow', params: { id: item.idCase['@id'] }}">
          {{getIdFromLink(item.idCase['@id'])}}
        </router-link>
      </td>
      <td>
        <span v-if="item.priced">{{$t('views.exsborder.list.priced')}}, </span>
        <span v-else-if="item.completed">{{$t('views.exsborder.list.completed')}}, </span>
        {{ item['orderStatus'].name }}
      </td>
      <td>
        {{ item['valueNetto'] }}
      </td>
      <td>
        {{ item['valueBrutto'] }}
      </td>
      <td>
        {{ item.firm.firmname1 === '' ? item.firm.fullName : item.firm.firmname1 }}
      </td>
      <td>
        <span v-for="tag in item.orderTags" :key="tag['@id']">
          <b-badge class="mr-2 mb-2 organizationleadtag" pill :style="{'background-color': tag.tag.color}"><i class="fa fa-tags mr-2"></i>{{tag.tag.tag}}</b-badge>
        </span>
      </td>
      <td>
        <div class="float-right">
          <b-dropdown size="sm" variant="link" right text="Right align" toggle-class="text-decoration-none" no-caret>
            <template #button-content>
              <i class="fa fa-bars fa-lg"></i>
            </template>
            <b-dropdown-item
              @click="showOrder(item['@id'])"
              aria-hidden="true">
              <i class="fa fa-search fa-lg"></i>
              {{ $t('buttons.show') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="getIdFromLink(item.orderStatus['@id']) === PLACED && ableToEditOrder"
              @click="editOrder(item['@id'])"
            >
              <i class="fa fa-edit fa-lg">
              </i>
              {{ $t('buttons.edit') }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item
              v-if="ableToChangeStatusOrder"
              @click="changeOrderStatus(item['@id'])"
            >
              <i class="fas fa fa-cogs fa-lg"></i>
              {{ $t('buttons.changeStatus') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="ableToDuplicateOrder"
              @click="duplicate(item['@id'])"
            >
              <i class="fas fa fa-copy fa-lg"></i>
              {{ $t('buttons.duplicate') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="ableToExtractOrder"
              @click="extractOrder(item['@id'])"
              @click.native.stop
            >
              <i class="fas fa fa-copy fa-lg"></i>
              {{ $t('buttons.extractOrder') }}
            </b-dropdown-item>
            <b-dropdown-divider></b-dropdown-divider>
            <b-dropdown-item v-if="item.state === 1 && ableToArchiveOrder"
              @click="archiveItem(item['@id'])"
            >
              <i class="fas fa fa-file-archive fa-lg"></i>
              {{ $t('buttons.archive') }}
            </b-dropdown-item>
            <b-dropdown-item v-if="item.state === 0 && ableToArchiveOrder"
                             @click="unArchiveItem(item['@id'])"
            >
              <i class="fas fa fa-file-archive fa-lg"></i>
              {{ $t('buttons.unArchive') }}
            </b-dropdown-item>
            <b-dropdown-item
              v-if="ableToDeleteOrder"
              @click="deleteItem(item['@id'])"
            >
              <i class="fas fa fa-trash fa-lg"></i>
              {{ $t('buttons.delete') }}
            </b-dropdown-item>
          </b-dropdown>
        </div>
      </td>
    </tr>
    </tbody>
  </table>
  <create-order-modal @reload="getPage(view)" v-if="duplicateOrderModalVisible" :initial-item="initialOrderItem" :id-case="initialOrderIdCase" :id-firm="initialOrderIdFirm" :id-extracted-order="extractedOrderId" :id-duplicated-order="duplicatedOrderId"></create-order-modal>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'
import getId from '@/utils/getIdFromLink'
import ApiService from '@/utils/ApiService'
import CreateOrderModal from '@/components/Dashboard/Views/BusinessBundle/exsborder/modals/CreateModal'
import { archive, unArchive } from '@/utils/archive'
import remove from '@/utils/remove'
import { checkPermission, getUserRoles } from '@/utils/checkRoles'

export default {
  name: 'Table',

  props: {
    getPage: {
      type: Function,
      required: true
    },
    items: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      idOrder: null,
      PLACED: 1,
      ACCEPTED: 2,
      PENDING: 3,
      COMPLETED: 4,
      CANCELLED: 5,
      ARCHIVED: 6,
      orderStatuses: {},
      duplicateOrderModalVisible: 0,
      initialOrderItem: {},
      initialOrderIdCase: null,
      initialOrderIdFirm: null,
      duplicatedOrderId: null,
      extractedOrderId: null
    }
  },
  mounted () {
    this.getOrderStatuses()
  },
  components: {
    CreateOrderModal
  },
  watch: {
    'duplicateOrderModalVisible' (val) {
      this.toggleCreateOrderModal()
    }
  },
  computed: {
    ...mapGetters({
      view: 'exsborder/list/view'
    }),
    isWholesaler () {
      return getUserRoles().roles.includes('ROLE_WHOLESALER')
    },
    ableToEditOrder () {
      if (this.isWholesaler) return false
      return checkPermission('orders', 'EXSBOrderUpdate')
    },
    ableToChangeStatusOrder () {
      if (!checkPermission('orders', 'EXSBOrderStatusChange')) return false
      return true
    },
    ableToDuplicateOrder () {
      if (this.isWholesaler) return false
      return checkPermission('orders', 'EXSBOrderCreate')
    },
    ableToExtractOrder () {
      if (!checkPermission('orders', 'EXSBOrderExtract')) return false
      if (this.isWholesaler) return false
      return true
    },
    ableToArchiveOrder () {
      if (this.isWholesaler) return false
      return checkPermission('orders', 'EXSBOrderUpdate')
    },
    ableToDeleteOrder () {
      if (this.isWholesaler) return false
      return true
    }
  },
  methods: {
    ...mapMutations({
      toggleModal: 'exsborder/showModal/toggleModal',
      toggleCreateOrderModal: 'exsborder/createModal/toggleModal'
    }),
    showOrder (id) {
      if (this.$route.name === 'EXSBOrderList') {
        this.$router.push({ name: 'EXSBOrderShow', params: { id: id } })
      }
    },
    editOrder (id) {
      this.$router.push({ name: 'EXSBOrderUpdate', params: { id: id } })
    },
    async changeOrderStatus (id) {
      const newStatus = await this.$Swal({
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.select'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel'),
        title: this.$t('buttons.changeStatus'),
        input: 'select',
        inputOptions: this.orderStatuses
      })
      if (newStatus) {
        let data = {
          '@id': id,
          orderStatus: newStatus
        }
        const response = await new ApiService(`e_x_s_b_orders/${getId(id)}`).put(data)
        if (response.status === 200) {
          this.getPage(this.view)
        }
      }
    },
    async extractOrder (id) {
      const decision = await this.$Swal({
        title: this.$t('views.exsborder.create.extractQuestion'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      })
      if (decision) {
        await this.duplicateOrderHandler(id, true)
      }
    },
    async duplicate (id) {
      const decision = await this.$Swal({
        title: this.$t('views.exsborder.create.duplicateQuestion'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        cancelButtonText: this.$t('buttons.no')
      })
      if (decision) {
        await this.duplicateOrderHandler(id)
      }
    },
    async duplicateOrderHandler (id, createNewCase = false) {
      if (!createNewCase) {
        this.duplicatedOrderId = id
        this.extractedOrderId = null
      } else {
        this.extractedOrderId = id
        this.duplicatedOrderId = null
      }
      const response = await new ApiService(`e_x_s_b_orders/${getId(id)}`).getResults()
      if (response['@id']) {
        let archivedOrder = response
        if (archivedOrder.idCase) {
          this.initialOrderIdCase = archivedOrder.idCase['@id']
          this.initialOrderIdFirm = archivedOrder.idCase.contractorUserData['@id']
        } else {
          this.initialOrderIdCase = null
          this.initialOrderIdFirm = archivedOrder.idFirm ? archivedOrder.idFirm : null
        }
        await this.duplicateOrder(id)
      }
    },
    async duplicateOrder (id) {
      const response = await new ApiService(id).getResults()
      this.initialOrderItem = {
        positions: response.positions.map(position => {
          return {
            item: position.item['@id'],
            vatRate: position.vatRate['@id'],
            quantity: position.quantity,
            measure: position.measure['@id']
          }
        }),
        orderTags: response.orderTags.map(orderTag => {
          return {
            value: orderTag.tag['@id'],
            text: orderTag.tag.tag
          }
        })
      }
      this.duplicateOrderModalVisible++
    },
    archiveItem (id) {
      archive(id, () => { this.getPage(this.view) })
    },
    unArchiveItem (id) {
      unArchive(id, () => { this.getPage(this.view) })
    },
    deleteItem (id) {
      remove(id, () => { this.getPage(this.view) })
    },
    getIdFromLink (link) {
      return parseInt(getId(link))
    },
    async getOrderStatuses () {
      let params = {
        'pagination': false,
        'state': 1
      }
      const response = await new ApiService('e_x_s_b_order_statuses', params).getResults()
      response.items.forEach(status => {
        this.orderStatuses[status['@id']] = status.name
      })
    }
  }
}
</script>

<style scoped>

</style>
